export const REPORT_HAS_NO_ACCESS_RESTRICTION = 'All users with project access';
